export const searchValueSelector = (state) => state.searchCompCards.searchValue;

export const searchCompCardResultSelector = (state) =>
  state.searchCompCards.searchResults;

export const searchCompCardsStateSelector = (state) =>
  state.searchCompCards.searchCompCardsState;

export const selectedCompCardSelector = (state) =>
  state.searchCompCards.selectedCompCard;

export const appliedCompCardsSelector = (state) =>
  state.searchCompCards.appliedCompCards;
